<template>
  <div class="cursor-pointer">
    <svg
      @mouseover="showHelp = true"
      @mouseleave="showHelp = false"
      xmlns="http://www.w3.org/2000/svg"
      class="h-5 w-auto rounded-full bg-indigo-600"
      viewBox="0 0 24 24"
      stroke-width="2"
      stroke="#FFFFFF"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M8 8a3.5 3 0 0 1 3.5 -3h1a3.5 3 0 0 1 3.5 3a3 3 0 0 1 -2 3a3 4 0 0 0 -2 4" />
      <line x1="12" y1="19" x2="12" y2="19.01" />
    </svg>

    <div class="fixed z-50">
      <transition
        enter-active-class="transition ease-out duration-200"
        leave-active-class="transition ease-in duration-150"
        enter-class="opacity-0 translate-y-1"
        enter-to-class="opacity-100 translate-y-0"
        leave-class="opacity-100 translate-y-0"
        leave-to-class="opacity-0 translate-y-1"
      >
        <div v-if="showHelp" class="absolute left-1/2 transform -translate-x-1/2 mt-3 px-2 w-screen max-w-lg sm:px-0">
          <div class="rounded-lg shadow-lg">
            <div class="rounded-lg shadow-xs overflow-hidden">
              <div class="z-20 relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
                <div class="-m-3 p-3 block space-y-1 rounded-md hover:bg-gray-50 transition ease-in-out duration-150">
                  <TeamHelp v-if="$route.name.includes('Team')" />
                  <ContactHelp v-if="$route.name.includes('Candidate')" />
                  <InboxHelp v-if="$route.name.includes('Inbox')" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import TeamHelp from '../team/TeamHelp.vue';
import ContactHelp from '../contact/ContactHelp.vue';
import InboxHelp from '../inbox/InboxHelp.vue';

export default {
  props: ['title', 'description'],
  components: {
    TeamHelp,
    ContactHelp,
    InboxHelp,
  },
  data() {
    return {
      showHelp: false,
    };
  },
};
</script>
